webpackJsonp([213628377533538],{

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MainPicture = __webpack_require__(21);
	
	var _MainPicture2 = _interopRequireDefault(_MainPicture);
	
	var _centraliserDonnees = __webpack_require__(102);
	
	var _centraliserDonnees2 = _interopRequireDefault(_centraliserDonnees);
	
	var _LeftPictureBackground = __webpack_require__(20);
	
	var _LeftPictureBackground2 = _interopRequireDefault(_LeftPictureBackground);
	
	var _target = __webpack_require__(819);
	
	var _target2 = _interopRequireDefault(_target);
	
	var _quality = __webpack_require__(178);
	
	var _quality2 = _interopRequireDefault(_quality);
	
	var _RightPicture = __webpack_require__(33);
	
	var _RightPicture2 = _interopRequireDefault(_RightPicture);
	
	var _CheckModule = __webpack_require__(32);
	
	var _CheckModule2 = _interopRequireDefault(_CheckModule);
	
	var _sf4life = __webpack_require__(814);
	
	var _sf4life2 = _interopRequireDefault(_sf4life);
	
	var _technologies = __webpack_require__(42);
	
	var _technologies2 = _interopRequireDefault(_technologies);
	
	var _symfony = __webpack_require__(41);
	
	var _symfony2 = _interopRequireDefault(_symfony);
	
	var _nodejs = __webpack_require__(40);
	
	var _nodejs2 = _interopRequireDefault(_nodejs);
	
	var _angularReact = __webpack_require__(37);
	
	var _angularReact2 = _interopRequireDefault(_angularReact);
	
	var _baseDeDonnee = __webpack_require__(38);
	
	var _baseDeDonnee2 = _interopRequireDefault(_baseDeDonnee);
	
	var _symfonyLogoCompressor = __webpack_require__(179);
	
	var _symfonyLogoCompressor2 = _interopRequireDefault(_symfonyLogoCompressor);
	
	var _htmlCssJs = __webpack_require__(39);
	
	var _htmlCssJs2 = _interopRequireDefault(_htmlCssJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpertSymfonyApp = function (_Component) {
	    _inherits(ExpertSymfonyApp, _Component);
	
	    function ExpertSymfonyApp() {
	        _classCallCheck(this, ExpertSymfonyApp);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ExpertSymfonyApp.prototype.render = function render() {
	        var title = "Expert Symfony";
	        var goto = "En découvrir plus";
	        var alt = "test";
	        var description = ["Symfony est un ", _react2.default.createElement(
	            "strong",
	            null,
	            "Framework Open-source Fran\xE7ais en PHP"
	        ), ". Un Framework est un ensemble de composants qui forment une base de développement solide. Tout en laissant une grande souplesse, un framework permet de ne pas avoir à réinventer la roue.", _react2.default.createElement("br", null), _react2.default.createElement("br", null), "Aujourd'hui ", _react2.default.createElement(
	            "strong",
	            null,
	            "Symfony"
	        ), " est une ", _react2.default.createElement(
	            "a",
	            { href: "/technologies-web", title: "D\xE9couvrir nos technologies Web" },
	            "technologie web"
	        ), " renommée et est utilisé au sein de nombreuses plateformes comme: BlaBlaCar, Meetic, Vogue, Total, ..."];
	        var smalltitle = "La flexibilité au service du web";
	        var titlemethodo = "Symfony pour quel type de projet ?";
	        var descriptionmethodo = ["Symfony peut répondre à toute sorte de projets web, web services, portails, outils métiers, site E-Commerce, CRM, ... Il n'est cependant pas particulièrement adapté pour la réalisation de simples pages. Voici quelques cas d'utilisations de Symfony:", _react2.default.createElement("br", null), _react2.default.createElement("br", null), _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Votre site vitrine :"
	                ),
	                " Vous avez besoin d'un espace client ? de communications avec d'autres outils m\xE9tiers ? Symfony conviendra parfaitement. il ne sera cependant pas adapt\xE9 \xE0 un ",
	                _react2.default.createElement(
	                    "a",
	                    { href: "/site-internet", target: "_blank", title: "Cr\xE9er son site Internet" },
	                    "site vitrine"
	                ),
	                " compos\xE9s de pages de contenu."
	            ),
	            _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Une application Web m\xE9tier :"
	                ),
	                " Afin de d\xE9velopper des ",
	                _react2.default.createElement(
	                    "a",
	                    { href: "/application-web", title: "Cr\xE9er des applications m\xE9tiers" },
	                    "outils m\xE9tiers"
	                ),
	                ", interconnect\xE9s avec votre syst\xE8me d'information ou non, symfony est parfaitement adapt\xE9. Ce framework permet d'int\xE9grer vos processus m\xE9tiers au sein de plateformes Web."
	            ),
	            _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Un portail d'entreprise Intranet ou Extranet :"
	                ),
	                "Que vous souhaitiez cr\xE9er un espace client / fournisseur ou encore un portail collaboratif interne, Symfony est parfaitement adapt\xE9 \xE0 ces besoins."
	            ),
	            _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Un autre besoin sur-mesure ?"
	                ),
	                " La robustesse, la g\xE9n\xE9ricit\xE9, la s\xE9curit\xE9 et la qualit\xE9 du framework Symfony lui permet d'\xEAtre adapt\xE9 \xE0 de nombeuses situations ou probl\xE9matiques."
	            )
	        ), "De manière général Symfony répond parfaitement aux problématiques complexes, à la mise en place d'API ou Web services, ou encore à la mise en place d'outils dynamiques."];
	        var pictureMethodo = _target2.default;
	        var altmethodo = "Méthodologie agile Scrum en image";
	
	        var smalltitleevol = "professionnalisme, normes et conventions...";
	        var titleevol = "Pourquoi Symfony ?";
	        var descriptionevol = ["Symfony est un framework dit professionel. Il impose une structure, des normes et des conventions que chaque développeur se doit de respecter. Parmis les avantages d'utiliser une telle plateforme on retrouve:", _react2.default.createElement("br", null), _react2.default.createElement("br", null), _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "L'architecture MVC"
	                ),
	                " (Mod\xE8le Vue Contr\xF4leur) impose une structure logique et m\xE9tier de l'application. Cette logique permet d'impl\xE9menter des processus m\xE9tiers complexe bien plus facilement."
	            ),
	            _react2.default.createElement(
	                "li",
	                null,
	                "Les fichiers de code web doivent ",
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "respecter les conventions et normes de d\xE9veloppements"
	                ),
	                " impos\xE9es. Cela garantit une facilit\xE9 de maintenance, compr\xE9hension et reprise du projet."
	            ),
	            _react2.default.createElement(
	                "li",
	                null,
	                "Symfony facilite l'impl\xE9mentation de ",
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "tests unitaires et fonctionnels"
	                ),
	                ". Ces tests permettent d'assurer une qualit\xE9 de code et une qualit\xE9 de rendu de la solution Web."
	            ),
	            _react2.default.createElement(
	                "li",
	                null,
	                "Une tr\xE8s forte communaut\xE9 Open-Source accompagne les d\xE9veloppements de Symfony. Cela assure une stabilit\xE9, une qualit\xE9, une innovation et une qualit\xE9 de documentation constante.  "
	            )
	        ), _react2.default.createElement("br", null), "Cette technologie permet de s'assurer d'une bonne ", _react2.default.createElement(
	            "strong",
	            null,
	            "qualit\xE9 de d\xE9veloppement"
	        ), ", de réutilisation et de résultat final associé à la diminution des bugs et autres régressions.", _react2.default.createElement("br", null), _react2.default.createElement("br", null), _react2.default.createElement(
	            "a",
	            { href: "https://www.symfony.com", title: "D\xE9couvrir Symfony", target: "_blank", rel: "nofollow" },
	            "Site officiel de Symfony"
	        )];
	
	        var altevol = "Intégration du portail dans votre système d'informations";
	
	        var smalltitleCheck = "Nativement rapide";
	        var titleCheck = "Conseils & expertise";
	        var subtitle1Check = "Des équipes expérimentées";
	        var text1Check = ["Nous proposons Symfony à nos client depuis la toute première version du framework (", _react2.default.createElement(
	            "a",
	            { href: "/symfony-5", title: "D\xE9couvrez les nouveaut\xE9s de Symfony 5" },
	            "La version 5 actuellement"
	        ), "). Notre expérience dans de multiples métiers comme l'agro-alimentaire, la santé, l'artisanat, l'IoT, la GMS GSB, ... pour ", _react2.default.createElement(
	            "a",
	            { href: "/realisation", title: "R\xE9alisations Web" },
	            "des projets"
	        ), " de toute taille nous permet de vous accompagner et conseiller au quotidien."];
	        var subtitle2Check = "Qualité";
	        var text2Check = "Pour l'ensemble des projets symfony que nous prenons en charge ou reprenons, nous mettons en place notre processus de développement éprouvé basé sur l'écriture de tests unitaires et fonctionnels automatisés.";
	        var subtitle3Check = "Souplesse";
	        var text3Check = "Afin de vous proposer un accompagnement pour votre projet le plus souple possible, nous travaillons à l'aide de la méthode Agile SCRUM qui vous assure une souplesse dans l'implémentation de votre projet.";
	        var pictureCheck = _quality2.default;
	        var altCheck = "La communication 360°";
	
	        return _react2.default.createElement(
	            "div",
	            { className: "generic-services" },
	            _react2.default.createElement(_MainPicture2.default, { title: "Qu'est-ce que Symfony ?", description: description, picture: _symfonyLogoCompressor2.default, alt: alt }),
	            _react2.default.createElement(_RightPicture2.default, { smalltitle: smalltitleevol, title: titleevol, description: descriptionevol, picture: _sf4life2.default, alt: altevol }),
	            _react2.default.createElement(_LeftPictureBackground2.default, { smalltitle: smalltitle, title: titlemethodo, description: descriptionmethodo, picture: pictureMethodo, alt: altmethodo }),
	            _react2.default.createElement(_CheckModule2.default, {
	                smalltitle: smalltitleCheck,
	                title: titleCheck,
	                subtitle1: subtitle1Check,
	                text1: text1Check,
	                subtitle2: subtitle2Check,
	                text2: text2Check,
	                subtitle3: subtitle3Check,
	                text3: text3Check,
	                picture: pictureCheck,
	                alt: altCheck
	            })
	        );
	    };
	
	    return ExpertSymfonyApp;
	}(_react.Component);
	
	exports.default = ExpertSymfonyApp;
	module.exports = exports["default"];

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/centraliser-donnees.14425800.png";

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quality.3ab2b4ce.png";

/***/ }),

/***/ 814:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sf4life.de19f614.png";

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/target.fc717f06.png";

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SocialLinks = __webpack_require__(16);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	var _SEO = __webpack_require__(14);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _ExpertSymfonyApp = __webpack_require__(290);
	
	var _ExpertSymfonyApp2 = _interopRequireDefault(_ExpertSymfonyApp);
	
	var _HeaderPage = __webpack_require__(15);
	
	var _HeaderPage2 = _interopRequireDefault(_HeaderPage);
	
	var _Menu = __webpack_require__(13);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(11);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _symf = __webpack_require__(182);
	
	var _symf2 = _interopRequireDefault(_symf);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Contact = __webpack_require__(19);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	__webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpertSymfony = function (_Component) {
	    _inherits(ExpertSymfony, _Component);
	
	    function ExpertSymfony() {
	        _classCallCheck(this, ExpertSymfony);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ExpertSymfony.prototype.render = function render() {
	        // SEO PURPOSES
	        var slug = this.props.pathContext.slug;
	
	
	        var postNode = {
	            "frontmatter": {
	                "title": "Experts développement Symfony",
	                "description": "Integral Service est une agence experte dans le conseil, l'architecture et le développement Symfony pour vos projets web.",
	                "cover": _symf2.default
	            }
	        };
	
	        var title = "Agence Web Symfony";
	        var description = "Le framework PHP open-source Français";
	        var goto = "En découvrir plus";
	
	        return _react2.default.createElement(
	            "div",
	            { className: "webapp-container page-details" },
	            _react2.default.createElement(_Header2.default, null),
	            _react2.default.createElement(_Menu2.default, null),
	            _react2.default.createElement(_reactHelmet2.default, {
	                title: "Experts d\xE9veloppement Symfony | " + _SiteConfig2.default.siteTitle,
	                description: "Integral Service est expert dans le conseil, l'architecture et le d\xE9veloppement Symfony pour vos projets web."
	            }),
	            _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	            _react2.default.createElement(_HeaderPage2.default, { title: title, description: description, picture: _symf2.default }),
	            _react2.default.createElement(_ExpertSymfonyApp2.default, null),
	            _react2.default.createElement(_Contact2.default, null),
	            _react2.default.createElement(_SocialLinks2.default, { postPath: slug, postNode: postNode }),
	            _react2.default.createElement(_Footer2.default, null)
	        );
	    };
	
	    return ExpertSymfony;
	}(_react.Component);
	
	exports.default = ExpertSymfony;
	
	;
	module.exports = exports["default"];

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/symf.342314a0.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-expert-symfony-jsx-48cf202ef5b6f66f0fe8.js